import {Routes} from '@angular/router';
import { Constant } from '../common/constant';
import { MaintenanceComponent } from '../common/components/maintenance/maintenance.component';
import { NotFoundComponent } from '../common/components/notFound/notFound.component';

export const CommonLayout_ROUTES: Routes = [

  { path: Constant.code_agent, loadChildren: () => import('../main/agent/agent.module').then(m => m.AgentModule)},
  { path: '503', component: MaintenanceComponent , data: { title: '503', header: '' }},
  { path: '**', component: NotFoundComponent, data: { title: 'Not Found', header: '' } }
];
